import { data } from '../components/agreement_and_privacy'

export function addPrivacy() {

    function addContent(addContentBtn, addContentTarget, content) {
        const btn = document.querySelectorAll(addContentBtn);
        const target = document.querySelector(addContentTarget);

        btn.forEach( item => {
            item.addEventListener('click', function() {
                if (target.classList.contains('is-init')) {
                    return false;
                }

                target.classList.add('is-init');
                target.innerHTML = content;
            });
        });
    }

    addContent('.js-addAgreement', '.js-agreementContent', data.agreement);
    addContent('.js-addPrivacy', '.js-privacyContent', data.privacy);
}
